module.exports = __webpack_public_path__ + "img/suzuki-s-cross.97b9ab77.jpg";